import { Button, Text } from '@radix-ui/themes'
import { useNavigate } from 'react-router-dom'

function NotFound() {
  const navigate = useNavigate()
  return (
    <div className="light h-screen w-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center justify-center text-center gap-8 px-4">
        <Text size="9" weight="medium" className="max-w-[650px]">
          The page you're looking for couldn't be found
        </Text>
        <Button
          className="max-w-[200px] my-4 w-full rounded cursor-pointer bg-mainBackground"
          onClick={() => navigate('/')}
        >
          Go Back to Home
        </Button>
      </div>
    </div>
  )
}

export default NotFound
